import {
  Component,
  ViewChild,
  TemplateRef,
  OnInit,
  Input,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldType, KreFormFieldConfig } from "@kre-form/core";
import { basename } from "path";

@Component({
  selector: "ion-field-demo",
  template: `
    <ion-input
      [formControl]="formControl"
      [ionKreFormAttributes]="field"
    ></ion-input>
  `,
})
export class IonFieldDemoTypeComponent extends FieldType implements OnInit {
  ngOnInit() {
    console.log(1);
  }

  public tt() {
    alert(0);
  }
}
